module.exports = __webpack_public_path__ + "static/media/logo_rounded.f7c650df.png";